// Affordable-housing factor table — rules/FACTOR_TABLES_MVP.md §3.
//
// The rule marks "配售型保障性住房" as not automatically calculable; we
// surface that as `null` and a separate `requiresManualReview` flag so
// the calculation layer can emit a warning instead of a silent 1.

import type { AffordableHousingType } from "../types/enums.js";

export interface AffordableHousingEntry {
  readonly housingType: AffordableHousingType;
  /** null means no automatic factor — manual review required. */
  readonly factor: number | null;
  readonly requiresManualReview: boolean;
}

export const AFFORDABLE_HOUSING_TABLE: Readonly<
  Record<AffordableHousingType, AffordableHousingEntry>
> = {
  公共租赁住房: {
    housingType: "公共租赁住房",
    factor: 0.01,
    requiresManualReview: false,
  },
  "保障性租赁住房-政府组织配租": {
    housingType: "保障性租赁住房-政府组织配租",
    factor: 0.04,
    requiresManualReview: false,
  },
  "保障性租赁住房-社会主体出租": {
    housingType: "保障性租赁住房-社会主体出租",
    factor: 0.2,
    requiresManualReview: false,
  },
  配售型保障性住房: {
    housingType: "配售型保障性住房",
    factor: null,
    requiresManualReview: true,
  },
};
